module.exports = __webpack_public_path__ + "static/externship-9c06ca4e666954e08d63f5950b317c54.jpg";